import { render } from "./Prepayment_Allocations.vue?vue&type=template&id=1ca6312f"
import script from "./Prepayment_Allocations.vue?vue&type=script&lang=js"
export * from "./Prepayment_Allocations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__